/* eslint-disable */
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when a handler could not be unsubscribed
 * @export
 * @class StorageCouldNotGetItemError
 * @extends {Error}
 */
export class StorageCouldNotGetItemError extends Error {
  /**
   * Creates an instance of StorageCouldNotGetItemError
   * @param {string} message The Error `message`
   * @memberof StorageCouldNotGetItemError
   */
  constructor(message) {
    super(message);
    this.name = `StorageCouldNotGetItemError`;
  }
}

/**
 * Called when a handler could not be unsubscribed
 * @param {string} key The name of the handler
 * @param {Error} error The caught Error
 * @returns {never} never
 */
const throwStorageCouldNotGetItemError = (key, error) => {
  throw new StorageCouldNotGetItemError(
    stripIndent(`
    Could not get key: "${key}" from Storage.

    Experienced:
    ${error.stack}
    `),
  );
};

export default throwStorageCouldNotGetItemError;
